var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as types from './types';
import * as statuses from '../../states';
var initialStages = [
    {
        id: 1,
        title: 'navigation.finance.title',
        actions: [
            {
                title: 'navigation.finance.society',
                link: '/configuration/society',
                status: 'todo',
            },
            {
                title: 'navigation.finance.valuation',
                link: '/configuration/valorisation',
                status: 'todo',
            },
        ],
    },
    {
        id: 2,
        title: 'navigation.showcase.title',
        actions: [
            {
                title: 'navigation.showcase.validate',
                link: '/configuration/project',
                status: 'todo',
            },
        ],
    },
    {
        id: 3,
        title: 'navigation.network.title',
        isOpen: true,
        actions: [
            {
                title: 'navigation.network.import',
                link: '/configuration/import',
                status: 'todo',
            },
            {
                title: 'navigation.network.contacts',
                link: '/configuration/contacts',
                status: 'todo',
            },
            {
                title: 'navigation.network.partner',
                link: '/configuration/partner',
                status: 'todo',
            },
        ],
    },
    {
        id: 4,
        title: 'navigation.campaignPreparation.title',
        actions: [
            {
                title: 'navigation.campaignPreparation.email',
                link: '/configuration/campaign/mail',
                status: 'todo',
            },
        ],
    },
    {
        id: 5,
        title: 'navigation.launch.title',
        actions: [
            {
                title: 'navigation.launch.send',
                link: '/configuration/launch',
                status: 'todo',
            },
        ],
    },
];
var getStagesFromPayload = function (payload) { return ([
    {
        id: 1,
        title: 'navigation.finance.title',
        actions: [
            {
                title: 'navigation.finance.society',
                status: payload.society,
                link: '/configuration/society',
            },
            {
                title: 'navigation.finance.valuation',
                status: payload.valuation,
                link: '/configuration/valorisation',
            },
        ],
    },
    {
        id: 2,
        title: 'navigation.network.title',
        isOpen: true,
        actions: [
            {
                title: 'navigation.network.import',
                status: payload.import,
                link: '/configuration/import',
            },
            {
                title: 'navigation.network.contacts',
                link: '/configuration/contacts',
                status: payload.import,
            },
            {
                title: 'navigation.network.partner',
                status: payload.partner,
                link: '/configuration/partner',
            },
        ],
    },
    {
        id: 3,
        title: 'navigation.showcase.title',
        actions: [
            {
                title: 'navigation.showcase.validate',
                status: payload.showcase,
                link: '/configuration/project',
            },
        ],
    },
    {
        id: 4,
        title: 'navigation.campaignPreparation.title',
        actions: [
            {
                title: 'navigation.campaignPreparation.email',
                status: payload.email,
                link: '/configuration/campaign/mail',
            },
            /* {
              title: 'navigation.campaignPreparation.sender',
              status: payload.sender,
              link: '/configuration/campaign/sender',
            }, */
            /* {
              title: 'navigation.campaignPreparation.social',
              status: payload.post,
              link: '/configuration/campaign/social',
            }, */
        ],
    },
    {
        id: 5,
        title: 'navigation.launch.title',
        actions: [
            {
                title: 'navigation.launch.send',
                status: payload.final,
                link: '/configuration/launch',
            },
        ],
    },
]); };
var initialState = {
    status: statuses.IDLE,
    validation: statuses.IDLE,
    stages: initialStages,
    rawStages: {
        campaign: 'wait',
        closing: 'wait',
        email: 'wait',
        iban: 'wait',
        final: 'wait',
        import: 'wait',
        partner: 'wait',
        post: 'wait',
        sales: 'wait',
        sender: 'wait',
        showcase: 'wait',
        social: 'wait',
        society: 'wait',
        valuation: 'wait',
    },
    valuation: {
        status: statuses.IDLE,
        validation: statuses.IDLE,
        isComplete: false,
        amountResearch: 0,
        capitalToTransfer: 0,
        emissionPrice: 0,
        preMoney: 0,
        nominalValue: 0,
        sharesNumber: 0,
        sharesPrice: 0,
        link: '',
    },
    showcase: {
        status: statuses.IDLE,
        validation: statuses.IDLE,
        pageStatus: 'preparation',
        page: null,
        calendar: null,
        token: '',
    },
    sender: {
        isFetching: false,
        status: false,
        email: null,
    },
};
function isRawStages(obj) {
    return typeof obj.final === 'string';
}
export default function configurationReducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.FETCH_CONFIGURATION_REQUEST:
            return __assign(__assign({}, state), { status: statuses.LOADING, sender: __assign(__assign({}, state.sender), { isFetching: true }) });
        case types.FETCH_CONFIGURATION_SUCCEEDED:
            if (!isRawStages(payload))
                return;
            if (payload.final === 'done') {
                return __assign(__assign({}, state), { status: statuses.SUCCESS, rawStages: {
                        campaign: 'run',
                        closing: 'wait',
                        email: 'done',
                        iban: payload.iban,
                        final: 'done',
                        import: 'done',
                        partner: 'done',
                        post: 'done',
                        sales: 'done',
                        sender: 'done',
                        showcase: 'done',
                        social: 'done',
                        society: 'done',
                        valuation: 'done',
                    }, stages: getStagesFromPayload({
                        campaign: 'run',
                        closing: 'wait',
                        email: 'done',
                        iban: payload.iban,
                        final: 'done',
                        import: 'done',
                        partner: 'done',
                        post: 'done',
                        sales: 'done',
                        showcase: 'done',
                        sender: 'done',
                        social: 'done',
                        society: 'done',
                        valuation: 'done',
                    }) });
            }
            return __assign(__assign({}, state), { status: statuses.SUCCESS, stages: getStagesFromPayload(__assign(__assign({}, payload), { society: 'done' })), rawStages: __assign(__assign({}, payload), { society: 'done' }) });
        case types.FETCH_CONFIGURATION_FAILED:
            return __assign(__assign({}, state), { status: statuses.FAIL });
        case types.FETCH_VALUATION_REQUEST:
            return __assign(__assign({}, state), { valuation: __assign(__assign({}, state.valuation), { status: statuses.IDLE }) });
        case types.FETCH_VALUATION_SUCCEEDED:
            if (typeof payload === 'string')
                return;
            return __assign(__assign({}, state), { valuation: __assign(__assign(__assign({}, state.valuation), payload), { status: statuses.SUCCESS }) });
        case types.FETCH_VALUATION_FAILED:
            return __assign(__assign({}, state), { valuation: __assign(__assign({}, state.valuation), { status: statuses.FAIL }) });
        case types.VALIDATE_VALUATION_REQUEST:
            return __assign(__assign({}, state), { valuation: __assign(__assign({}, state.valuation), { validation: statuses.LOADING }) });
        case types.VALIDATE_VALUATION_SUCCEEDED:
            return __assign(__assign({}, state), { valuation: __assign(__assign({}, state.valuation), { validation: statuses.SUCCESS }), rawStages: __assign(__assign({}, state.rawStages), { valuation: 'done' }), stages: getStagesFromPayload(__assign(__assign({}, state.rawStages), { valuation: 'done' })) });
        case types.VALIDATE_VALUATION_FAILED:
            return __assign(__assign({}, state), { valuation: __assign(__assign({}, state.valuation), { validation: statuses.FAIL }) });
        case types.FETCH_SHOWCASE_PAGE_REQUEST:
            return __assign(__assign({}, state), { showcase: __assign(__assign({}, state.showcase), { status: statuses.LOADING }) });
        case types.FETCH_SHOWCASE_PAGE_SUCCEEDED:
            if (typeof payload === 'string')
                return;
            return __assign(__assign({}, state), { showcase: __assign(__assign(__assign({}, state.showcase), payload), { status: statuses.SUCCESS }) });
        case types.FETCH_SHOWCASE_PAGE_FAILED:
            return __assign(__assign({}, state), { showcase: __assign(__assign({}, state.showcase), { status: statuses.FAIL }) });
        case types.VALIDATE_SHOWCASE_REQUEST:
            return __assign(__assign({}, state), { showcase: __assign(__assign({}, state.showcase), { validation: statuses.LOADING }) });
        case types.VALIDATE_SHOWCASE_SUCCEEDED:
            return __assign(__assign({}, state), { showcase: __assign(__assign({}, state.showcase), { validation: statuses.SUCCESS, pageStatus: 'validated' }) });
        case types.VALIDATE_SHOWCASE_FAILED:
            return __assign(__assign({}, state), { showcase: __assign(__assign({}, state.showcase), { validation: statuses.FAIL }) });
        case types.VALIDATE_CONFIGURATION_REQUEST:
            return __assign(__assign({}, state), { validation: statuses.LOADING });
        case types.VALIDATE_CONFIGURATION_SUCCEEDED:
            return __assign(__assign({}, state), { validation: statuses.SUCCESS, rawStages: {
                    campaign: 'run',
                    closing: 'wait',
                    email: 'done',
                    final: 'done',
                    import: 'done',
                    partner: 'done',
                    post: 'done',
                    sales: 'done',
                    sender: 'done',
                    showcase: 'done',
                    social: 'done',
                    society: 'done',
                    valuation: 'done',
                }, stages: getStagesFromPayload({
                    campaign: 'run',
                    closing: 'wait',
                    email: 'done',
                    final: 'done',
                    import: 'done',
                    partner: 'done',
                    post: 'done',
                    sales: 'done',
                    showcase: 'done',
                    sender: 'done',
                    social: 'done',
                    society: 'done',
                    valuation: 'done',
                }) });
        case types.VALIDATE_CONFIGURATION_FAILED:
            return __assign(__assign({}, state), { validation: statuses.FAIL });
        case types.SET_SOCIETY_STAGES:
            if (!payload || typeof payload === 'string' || !('name' in payload))
                return;
            return __assign(__assign({}, state), { rawStages: __assign(__assign({}, state.rawStages), (_a = {}, _a[payload.name] = payload.value, _a)), stages: getStagesFromPayload(__assign(__assign({}, state.rawStages), (_b = {}, _b[payload.name] = payload.value, _b))) });
        case types.SET_EMAIL_SENDER:
            return __assign(__assign({}, state), { rawStages: __assign(__assign({}, state.rawStages), { sender: 'done' }), stages: getStagesFromPayload(__assign(__assign({}, state.rawStages), { sender: 'done' /* Waiting for ms gestion camp : payload && payload !== '' ? 'done' : 'todo' */ })), sender: {
                    isFetching: false,
                    status: payload && payload !== '',
                    email: payload,
                } });
        default:
            return state;
    }
}
